
function computeLevels (nodes,adj) {

    let nodesTemp = [...nodes]
    let level = 0

    while (nodesTemp.length) {

        const currentLevelNodes = nodesTemp.filter(node => node.level === level)

        nodesTemp = nodesTemp.filter(node => node.level !== level)

        if(!currentLevelNodes.length) { // escape infinite loop, there may still be no-connection nodes, will check later
            break;
        }

        for (let i = 0; i < currentLevelNodes.length; i++) {
            const node = currentLevelNodes[i]

            adj[node.id].forEach((adjacentNodeId) => {
                const index = nodesTemp.findIndex(n => n.id === adjacentNodeId)
                if(index !== -1 && nodesTemp[index].level === -1) {
                    nodesTemp[index].level = level + 1
                }
            })
        }

        level++
    }

    nodesTemp.forEach(node => {
        node.level = level
        node.isFree = true
    }) // no-connection nodes

}

function getSortedNodesByLevels (nodes,adj) {
    const levels = []

    nodes.forEach(node => {
        if(levels[node.level]) {
            levels[node.level].push(node)
        }else{
            levels[node.level] = [node]
        }
    })

    if(levels.length > 1) {
        levels[1].sort((a, b) => a.id - b.id)
    }

    for(let i = 2; i < levels.length; i++) {
        levels[i].forEach((node) => {
            node.parentIndex = levels[i-1].findIndex(n => adj[n.id].includes(node.id))
        })

        levels[i].sort((a, b) => a.parentIndex - b.parentIndex)
    }

    return levels
}

export { computeLevels, getSortedNodesByLevels }


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/GraphView/services/NodeLevelService.js